import React, { Component }                from 'react'
import {connect}                           from 'react-redux';
import FlashCarregando                     from '../../../container/FlashCarregando';
import { GetListGrupo,
         GetListProfessorTurmaDisciplina } from '../../../actions/grupoAction';
import {SetError}                          from '../../../actions/notificacaoAction';
import { GetListaMenuTopo,
         GetListaSubMenuTopo }             from '../../../actions/scopoAction';
import Disciplina             from "../disciplina/professor_disciplina";

class Equipe_Professor extends Component {

    constructor(props){
       super(props);
       this.state = {  load : false }
    }

    componentWillMount() {
       
      this.props.GetListProfessorTurmaDisciplina(this.props.session.id).then((response) => {
          this.setState({load:true});      
      }).catch((error) =>{
          this.props.SetError(500);
      });
    
      this.props.GetListaMenuTopo([
                                   {
                                    action : true,
                                    nome   : "Home",
                                    link   : this.props.menu.home
                                   },
                                   {
                                    action : false,
                                    nome   : 'Comunicação'
                                   },
                                   {
                                    action : false,
                                    nome   : 'Unidade Curricular'
                                   }
                                  ]);
  
      this.props.GetListaSubMenuTopo([]);
  
    }

    render () {
        
        return (
                <div className="container-bg">
                  {!this.state.load? <FlashCarregando/> : <Disciplina timeline={true} menuParametro={this.props.menu.equipe.professor.equipe_turma}/>}
                </div>
               )
    }
}

function mapStateToProps(state){
   return { 
            session : state.auth.session,
            menu    : state.configReducer.menu
          };
}

export default connect(mapStateToProps,{GetListGrupo,SetError,GetListaMenuTopo,GetListProfessorTurmaDisciplina,GetListaSubMenuTopo})(Equipe_Professor);


// WEBPACK FOOTER //
// ./src/components/professor/equipe/equipe_professor.js